export default "__VITE_ASSET__a0xMKGn7__"